import apiFetch from '../../apiFetch'

export default function (idTipoIntervencion, token) {
  return apiFetch({endPoint: `TipoIntervencion/getTipoIntervencion?idTipoIntervencion=${idTipoIntervencion}`, method: 'GET', body: null, token: token})
}
